import React from "react";
import { Controller } from "react-hook-form";
import type { PathArray } from "common/utils/formStructure";
import { SubmissionDefaultValueFieldType } from "../../../../../../../../generated/graphql";
import { useSubmissionDefaultValueOptions } from "../../../../../../../../hooks/useSubmissionDefaultValueOptions";
import Select from "../../../../../../../Inputs/Select";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../../form/form";

type TextDynamicDefaultInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function TextDynamicDefaultInput({
  fieldPath,
  isReadOnly,
}: TextDynamicDefaultInputProps) {
  const { control } = useBuilderFormContext();
  const defaultValuePathPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValuePath",
  );
  const defaultValuePath = useBuilderWatch(defaultValuePathPropertyFormPath);

  const { options, loading, error } = useSubmissionDefaultValueOptions({
    fieldType: SubmissionDefaultValueFieldType.TEXT,
  });

  return (
    <Controller
      control={control}
      name={defaultValuePathPropertyFormPath}
      render={({ field }) => {
        return (
          <Select
            value={defaultValuePath ?? null}
            isClearable={true}
            label="Dynamic default value"
            name={defaultValuePathPropertyFormPath}
            isLoading={loading}
            options={options}
            error={error?.message}
            onChange={value => {
              field.onChange(value ?? undefined);
            }}
            disabled={isReadOnly}
          />
        );
      }}
    />
  );
}
